import {Injectable, signal} from '@angular/core';
import {NoScrollService} from '../../services/no-scroll.service';

@Injectable({
  providedIn: 'root',
})
export class SidebarNavService {
  public isMenuOpen = signal<boolean>(false);

  constructor(private noScroll: NoScrollService) {}

  public openSidebarNav() {
    this.isMenuOpen.set(true);
    this.noScroll.setScrollBlocked(true);
  }

  public closeSidebarNav(): void {
    this.isMenuOpen.set(false);
    this.noScroll.setScrollBlocked(false);
  }

  public toggleSidebarNav(): void {
    if (this.isMenuOpen()) {
      this.closeSidebarNav();
    } else {
      this.openSidebarNav();
    }
  }
}
